import {NAME} from './constants';

export const SHOW_DIALOG = `${NAME}/SHOW_DIALOG`;
export const HIDE_DIALOG = `${NAME}/HIDE_DIALOG`;